import React, { useEffect, useState } from 'react';
import {  Card, CardContent } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import MUIDataTable from 'mui-datatables';
import { Delete, Edit } from '@material-ui/icons';
import CustomeSearch from '../../../components/CustomSearch';
import DeleteDialog from '../../../components/DeleteDialog';
import NewSafetyConfig from '../NewSafetyConfig';
import { fetchSafetyConfigs, removeSafetyConfig } from '../../../redux/actions/safety';

const List = () => {
  const [isDeleteOpen, setIsDeleteOpen] = useState(false);
  const [selectedId, setSelectedId] = useState('');
  const [isNewOpen, setIsNewOpen] = useState(false);
  const [config, setConfig] = useState(null);

  const dispatch = useDispatch();
  const { safetyConfigs } = useSelector(({ safety }) => safety);

  useEffect(() => {
    dispatch(fetchSafetyConfigs());
  }, []);

  const columns = [
    // { name: 'key', label: 'Key' },
    { name: 'label', label: 'Label' },
    { name: 'value', label: 'Value' },
    {
      name: 'id',
      label: 'Actions',
      options: {
        customBodyRender: (value) => (
          <>
            <Edit
              style={{ cursor: 'pointer' }}
              color="primary"
              onClick={() => {
                setConfig((safetyConfigs || []).find((item) => item.id === value));
                setIsNewOpen(true);
              }}
            />
            <Delete
              style={{ color: 'red', cursor: 'pointer' }}
              onClick={() => {
                setSelectedId(value);
                setIsDeleteOpen(true);
              }}
            />
          </>
        )
      }
    }
  ];

  return (
    <Card className="userlist">
      <CardContent>
        {/* <div className="userlist__header">
          <Button size="medium" color="primary" variant="contained" onClick={() => setIsNewOpen(true)}>
            New Safety Config
          </Button>
        </div> */}
        <MUIDataTable
          title="Safety Config"
          data={safetyConfigs || []}
          columns={columns}
          options={{
            filterType: 'textField',
            responsive: 'standard',
            selectableRows: 'none',
            elevation: 0,
            customSearchRender: (searchText, handleSearch, hideSearch) => (
              <CustomeSearch handleSearch={handleSearch} hideSearch={hideSearch} />
            ),
            print: false,
            viewColumns: false,
            download: false
          }}
        />
      </CardContent>

      <DeleteDialog
        open={isDeleteOpen}
        handleClose={() => {
          setIsDeleteOpen(false);
          setSelectedId('');
        }}
        handleOk={() => {
          dispatch(removeSafetyConfig(selectedId));
          setIsDeleteOpen(false);
          setSelectedId('');
        }}
        message="Are you sure you want to delete this safety config?"
      />
      {isNewOpen && (
        <NewSafetyConfig
          open={isNewOpen}
          config={config}
          handleClose={() => {
            setIsNewOpen(false);
            setConfig(null);
          }}
          handleOk={() => {
            setIsNewOpen(false);
            setConfig(null);
            dispatch(fetchSafetyConfigs());
          }}
        />
      )}
    </Card>
  );
};

export default List;
